import { gql } from 'graphql-request';
import {
  InventoryDashboard,
  Nullable,
  UserWithToken,
  WithData,
  OrganizerDashboard,
  TodayDashboard,
} from '@ygoargentina/sdk/api/api.types';
import { getGraphQLQueryClient } from './query-client';

export const getInventoryDashboard = (user: Nullable<UserWithToken>) =>
  getGraphQLQueryClient(user).request<WithData<InventoryDashboard>>(gql`
    query inventoryDashboard {
      data: inventoryDashboard {
        boxes
        inventory
        decks
      }
    }
  `);

export const getOrganizerDashboard = (user: Nullable<UserWithToken>) =>
  getGraphQLQueryClient(user).request<WithData<OrganizerDashboard>>(gql`
    query organizerDashboard {
      data: organizerDashboard {
        tournamentsPublished
        tournamentsPending
        tournamentsRunning
        tournamentsFinished
        tournamentsCancelled
        tournamentsNotRunned
        tournamentsUnreported
      }
    }
  `);

export const getTodayDashboard = (user: Nullable<UserWithToken>) =>
  getGraphQLQueryClient(user).request<WithData<TodayDashboard>>(gql`
    query todayDashboard {
      data: todayDashboard {
        tournaments
        players
      }
    }
  `);
